export function OTAInfo() {
  return null
}
